export const CaseStudies = () => {
  const cases = [
    {
      title: 'Downtown 6-Story Building',
      location: 'Urban Core',
      details: {
        units: '48 units',
        condition: 'Deferred maintenance',
        timeline: '35 days to close',
        challenge: 'Aging building systems and below-market rents'
      },
      story: 'The owner had inherited this property and was overwhelmed by the capital needs and management requirements. We provided a fair cash offer that accounted for the needed improvements and closed quickly, allowing the seller to move forward with their life.',
      outcome: 'Seller received full cash payment at closing with no repair obligations or ongoing management stress.'
    },
    {
      title: '7-Story Elevator Building',
      location: 'Suburban Transit Hub',
      details: {
        units: '72 units',
        condition: 'Well-maintained',
        timeline: '42 days to close',
        challenge: 'Partnership dissolution needed'
      },
      story: 'Three partners who had owned this property for 15 years wanted to go their separate ways. We structured a purchase that satisfied all parties and provided a clean exit for everyone involved.',
      outcome: 'All three partners received their share of proceeds and were able to pursue individual investment strategies.'
    },
    {
      title: '5-Story Mixed-Use Property',
      location: 'City Center',
      details: {
        units: '40 residential + retail',
        condition: 'Value-add opportunity',
        timeline: '38 days to close',
        challenge: 'Vacant retail space and management issues'
      },
      story: 'The seller was struggling with vacant ground-floor retail and residential tenant turnover. We saw the potential and made an offer that reflected both current challenges and future upside.',
      outcome: 'Seller avoided further carrying costs and management headaches while receiving a competitive price.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Recent Mid-Rise Acquisitions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Real examples of mid-rise apartment buildings we've purchased and the solutions we provided to sellers.
          </p>
        </div>

        <div className="space-y-8">
          {cases.map((caseStudy, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="grid md:grid-cols-3 gap-8 p-8">
                <div className="md:col-span-1">
                  <div className="bg-gradient-to-br from-teal-500 to-cyan-600 text-white rounded-xl p-6">
                    <h3 className="text-2xl font-bold mb-2">{caseStudy.title}</h3>
                    <p className="text-white/90 mb-6">{caseStudy.location}</p>
                    <div className="space-y-3">
                      <div className="flex items-center">
                        <i className="ri-building-line mr-3 text-xl"></i>
                        <span>{caseStudy.details.units}</span>
                      </div>
                      <div className="flex items-center">
                        <i className="ri-tools-line mr-3 text-xl"></i>
                        <span>{caseStudy.details.condition}</span>
                      </div>
                      <div className="flex items-center">
                        <i className="ri-time-line mr-3 text-xl"></i>
                        <span>{caseStudy.details.timeline}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="md:col-span-2">
                  <div className="mb-6">
                    <h4 className="text-lg font-semibold mb-2 text-gray-900">The Challenge:</h4>
                    <p className="text-gray-600 leading-relaxed">{caseStudy.details.challenge}</p>
                  </div>
                  <div className="mb-6">
                    <h4 className="text-lg font-semibold mb-2 text-gray-900">The Story:</h4>
                    <p className="text-gray-700 leading-relaxed">{caseStudy.story}</p>
                  </div>
                  <div className="bg-teal-50 rounded-lg p-6">
                    <h4 className="text-lg font-semibold mb-2 text-teal-900">The Outcome:</h4>
                    <p className="text-teal-800 leading-relaxed">{caseStudy.outcome}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-xl text-gray-600 mb-8">
            Every mid-rise property and seller situation is unique. We'd like to learn about yours.
          </p>
          <a 
            href="#get-offer" 
            className="whitespace-nowrap inline-block bg-teal-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-600 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            Share Your Property Details
          </a>
        </div>
      </div>
    </section>
  );
};